import { render, staticRenderFns } from "./retur-set-price-balance-form.vue?vue&type=template&id=31710e43&"
import script from "./retur-set-price-balance-form.vue?vue&type=script&lang=js&"
export * from "./retur-set-price-balance-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports